/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import AuditTrailDetails from "../../../components/Administrations/AuditTrails/AuditTrailDetails";

const AuditTrails: React.FC = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="pt-1 pl-3 mr-4">
        <AuditTrailDetails />
      </div>
    </div>
  );
};

export default AuditTrails;
